var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProofreadSegmentError = function SvgIconProofreadSegmentError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_proofread_segment_error_svg__a",
    width: 22,
    height: 20,
    x: 1,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#555",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M12.721 3.582a.833.833 0 0 0-1.442 0l-9 15.546A.833.833 0 0 0 3 20.378h18a.833.833 0 0 0 .721-1.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.667,
    d: "M12 16.274v.41m0-6.955.003 4.09"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_proofread_segment_error_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E00751",
    d: "M.055.072h23.563v23.564H.055z"
  }))));
};
export default SvgIconProofreadSegmentError;